import { useState } from 'react';
import { Pressable, View } from 'react-native';

import { Text } from '@/components/ui';
import { cn } from '@/lib/design-system/cn';
import { monthLabel } from '@/lib/finance/month';

import { AccountActivityReport } from './AccountActivityReport.web';
import { BalancesReport } from './BalancesReport.web';
import { BudgetVsActual } from './BudgetVsActual.web';
import { IncomeVsExpense } from './IncomeVsExpense.web';
import { OverTimeReport } from './OverTimeReport.web';

type ReportKey =
  | 'budget-vs-actual'
  | 'income-vs-expense'
  | 'balances'
  | 'account-activity'
  | 'budgets-over-time'
  | 'actuals-over-time'
  | 'actual-vs-budget-over-time';

const REPORTS: { key: ReportKey; label: string }[] = [
  { key: 'budget-vs-actual', label: 'Budget vs Actual' },
  { key: 'income-vs-expense', label: 'Income vs Expense' },
  { key: 'balances', label: 'Balances' },
  { key: 'account-activity', label: 'Account activity' },
  { key: 'budgets-over-time', label: 'Budgets over time' },
  { key: 'actuals-over-time', label: 'Actuals over time' },
  { key: 'actual-vs-budget-over-time', label: 'Actual vs Budget over time' },
];

export function ReportsTab({ month }: { month: string }) {
  const [report, setReport] = useState<ReportKey>('budget-vs-actual');

  return (
    <View>
      <View className="mb-4 flex-row flex-wrap items-center gap-2">
        <View className="flex-row gap-1 rounded-lg bg-surface-raised p-1">
          {REPORTS.map((item) => {
            const active = item.key === report;
            return (
              <Pressable
                key={item.key}
                className={cn('rounded-md px-3 py-1.5', active ? 'bg-surface' : '')}
                onPress={() => setReport(item.key)}
              >
                <Text
                  variant="body-sm"
                  className={active ? 'font-semibold text-accent' : 'text-muted'}
                >
                  {item.label}
                </Text>
              </Pressable>
            );
          })}
        </View>
        <View className="flex-1" />
        <Text variant="body-sm" className="text-muted">
          {monthLabel(month)} · USD
        </Text>
      </View>

      {report === 'budget-vs-actual' ? (
        <BudgetVsActual month={month} />
      ) : report === 'income-vs-expense' ? (
        <IncomeVsExpense month={month} />
      ) : report === 'balances' ? (
        <BalancesReport month={month} />
      ) : report === 'account-activity' ? (
        <AccountActivityReport month={month} />
      ) : report === 'budgets-over-time' ? (
        <OverTimeReport month={month} metric="budget" />
      ) : report === 'actuals-over-time' ? (
        <OverTimeReport month={month} metric="actual" />
      ) : (
        <OverTimeReport month={month} metric="difference" />
      )}
    </View>
  );
}
